import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import Item from '../../../shared/TechSkills/Item';
import AddItem from '../../../shared/TechSkills/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const DataBasesTab = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('dataBases' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'dataBases',
          value: {
            enable: false,
            heading: 'Databases',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'dataBases' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('dataBases.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.dataBases.enable}
              onChange={v => onChange('data.dataBases.enable', v)}
            />
          </div>

        </div>

        <hr className="my-6"/>
        
        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="dataBases"
        >
          {data.dataBases.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.dataBases.items.length - 1}
              type="dataBases"
              idTab={config.TECH_SKILLS_TABS.dataBases}
            />
          ))}
        </DragNDropList>

        <AddItem heading='Database' dispatch={dispatch} type='dataBases' idTab={config.TECH_SKILLS_TABS.dataBases} />
      </>
    )
  );
};

export default DataBasesTab;
